import {
  Button,
  Card,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import VeerisettyCollege from './TC-Forms/VeerisettyCollege/VeerisettyCollege';
import VeerisettyCollegeEmptyTC from './TC-Forms/VeerisettyCollege/VeerisettyCollegeEmptyTC';
import { useSelector } from 'react-redux';
import VeerisettyCollegeDegree from './TC-Forms/VeerisettyCollege/VeerisettyCollegeDegree';
import VeerisettyCollegeDegreeEmptyTC from './TC-Forms/VeerisettyCollege/VeerisettyCollegeDegreeEmptyTC';
export default function TCPage() {
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const [StudentId, setStudentId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [emptyTC, setEmptyTC] = useState(false);
  return (
    <>
      {' '}
      <Card className='max-w-5xl p-4 border-t '>
        <div className='max-w-5xl pb-6 '>
          <Typography variant='h6' className='text-blue-600'>
            {' '}
            Search Student
          </Typography>
          <Card className='p-4 mb-4 border rounded '>
            <Typography variant='body1' className='mb-2'>
              Enter Student Id and search for managing the Transfer Certificate
              Details.
            </Typography>
            <div className='flex flex-wrap items-end gap-2'>
              <TextField
                value={searchValue}
                id='studentId'
                size='small'
                label='Student Id'
                className='mt-2 mr-10 w-60'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {!!searchValue && (
                        <IconButton
                          onClick={() => {
                            setSearchValue('');
                            setStudentId('');
                          }}
                        >
                          <CloseIcon></CloseIcon>
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchValue(e.target.value)}
              ></TextField>

              <Button
                variant='contained'
                disabled={!searchValue}
                onClick={() => {
                  setStudentId(searchValue);
                  setEmptyTC(false);
                }}
              >
                Search
              </Button>
            </div>
          </Card>
          {!StudentId && !emptyTC && (
            <>
              <b className='text-red-600'> Note : </b>To issue TC manually{' '}
              <b
                className='text-blue-600 hover:underline hover:cursor-pointer'
                onClick={() => {
                  setEmptyTC(true);
                  setStudentId('');
                }}
              >
                click
              </b>{' '}
              here.
            </>
          )}
        </div>{' '}
        {!emptyTC && (
          <Typography variant='h6' className='text-blue-600'>
            {' '}
            Transfer Certificate Details :
          </Typography>
        )}
        {emptyTC && (
          <>
            <div className='flex justify-between'>
              {' '}
              <Typography variant='h6' className='text-blue-600'>
                {' '}
                Issue Transfer Certificate Manually :
              </Typography>{' '}
              <Tooltip title='Close'>
                <IconButton
                  onClick={() => {
                    setEmptyTC(false);
                    setStudentId('');
                  }}
                >
                  <CloseIcon color='primary' className='text-3xl'></CloseIcon>
                </IconButton>
              </Tooltip>
            </div>
          </>
        )}
        {!emptyTC && instituteType?.toLowerCase() === 'college' && (
          <VeerisettyCollegeDegree StudentId={StudentId} />
        )}
        {emptyTC && instituteType?.toLowerCase() === 'college' && (
          <VeerisettyCollegeDegreeEmptyTC></VeerisettyCollegeDegreeEmptyTC>
        )}
        {!emptyTC && instituteType?.toLowerCase() !== 'college' && (
          <VeerisettyCollege StudentId={StudentId} />
        )}
        {emptyTC && instituteType?.toLowerCase() !== 'college' && (
          <VeerisettyCollegeEmptyTC></VeerisettyCollegeEmptyTC>
        )}
      </Card>
    </>
  );
}
